export const tracksChartMock = [
  { name: '01 2024', value: 735 },
  { name: '02 2024', value: 6802 },
  { name: '03 2024', value: 185 },
  { name: '04 2024', value: 811 },
  { name: '05 2024', value: 575 },
  { name: '06 2024', value: 6838 },
  { name: '07 2024', value: 1011 },
  { name: '08 2024', value: 9512 },
  { name: '09 2024', value: 898 },
  { name: '10 2024', value: 4351 },
  { name: '11 2024', value: 1005 },
  { name: '12 2024', value: 1127 },
];
